import { default as Endpoint } from '../../api/Endpoint';
import * as Constants from '../constants';

export function requestProfile() {
  return {
    type: Constants.REQUEST_PROFILE
  };
}

export function receiveProfile(json, error) {
  return {
    type: Constants.RECEIVE_PROFILE,
    data: json,
    error
  };
}

export function updateProfileTag(tag) {
  return {
    type: Constants.UPDATE_PROFILE_TAG,
    tag
  };
}

export function deleteProfileTag(tag) {
  return {
    type: Constants.DELETE_PROFILE_TAG,
    tag
  };
}

export function requestUpdateProfile() {
  return {
    type: Constants.REQUEST_UPDATE_PROFILE
  };
}

export function receiveUpdateProfile(json, error) {
  return {
    type: Constants.RECEIVE_UPDATE_PROFILE,
    data: json,
    error
  };
}

export function requestUploadProfile() {
  return {
    type: Constants.REQUEST_UPLOAD_PROFILE
  };
}

export function receiveUploadProfile(json, error) {
  return {
    type: Constants.RECEIVE_UPLOAD_PROFILE,
    data: json,
    error
  };
}

export function requestBlocks() {
  return {
    type: Constants.REQUEST_BLOCKS
  };
}
export function receiveBlocks(json, error) {
  return {
    type: Constants.RECEIVE_BLOCKS,
    data: json,
    error
  };
}

export function fetchBlocks() {
  const path = 'ecs/api/block';
  return new Endpoint(path, requestBlocks, receiveBlocks).call();
}

export function fetchProfile(subscriberId, options = {}) {
  const path = `ecs/api/profile/${subscriberId}`;
  return new Endpoint(path, requestProfile, receiveProfile)
    .withOptions(options)
    .call();
}

export function saveProfile(subscriberId, profile, options = {}) {
  const path = `ecs/api/profile/${subscriberId}`;
  const profileObject = {
    id: profile.profile,
    tags: profile.tags
  };
  const payload = JSON.stringify(profileObject);
  return new Endpoint(path, requestUpdateProfile, receiveUpdateProfile)
    .withBody(payload)
    .withMethod('POST')
    .withOptions(options)
    .call();
}

export function uploadProfile(formData, options = {}) {
  const path = 'ecs/api/profile_upload';
  return new Endpoint(path, requestUploadProfile, receiveUploadProfile)
    .withMethod('POST')
    .withBody(formData)
    .withOptions(options)
    .call();
}
